module.exports = __webpack_public_path__ + "img/booth_03.756a2faf.png";